export default {"src":"/_next/static/media/gulu.08c7a804.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};